export const AI_DISCOVERY_VIDEO_IT_FILE_NAME =
    'conversational_ai_discovery.mp4';
export const AI_DISCOVERY_VIDEO_EN_FILE_NAME =
    'conversational_ai_discovery_en.mp4';
